<template>
    <div class="mt-3">
        <div class="data-container">
            <b-table :items="list"
                :fields="fields"
                :current-page="page"
                ref="AssetMasterList"
                responsive
                show-empty
                :empty-text="(loading) ? 'Loading data' : 'No Data Available'">
                <template slot="country" slot-scope="data">
                    <span class="d-flex">
                        <span class="border-right pr-2">{{ data.item.country_code }}</span>
                        <span class="pl-2">{{ data.item.country_name }}</span>
                    </span>
                </template>
                <template slot="dt" slot-scope="data">
                    <span class="d-flex">
                        <span class="border-right pr-2">{{ data.item.dt_code }}</span>
                        <span class="pl-2">{{ data.item.dt_name }}</span>
                    </span>
                </template>
                <template slot="site" slot-scope="data">
                    <span class="d-flex">
                        <span class="border-right pr-2">{{ data.item.site_code }}</span>
                        <span class="pl-2">{{ data.item.site_name }}</span>
                    </span>
                </template>
                <template slot="salesman" slot-scope="data">
                    <span class="d-flex">
                        <span class="border-right pr-2">{{ data.item.salesman_code }}</span>
                        <span class="pl-2">{{ data.item.salesman_name }}</span>
                    </span>
                </template>
                <template slot="outlet" slot-scope="data">
                    <span class="d-flex">
                        <span class="border-right pr-2">{{ data.item.outlet_code }}</span>
                        <span class="pl-2">{{ data.item.outlet_name }}</span>
                    </span>
                </template>
                <template slot="asset" slot-scope="data">
                    <span class="d-flex">
                        <span class="border-right pr-2">{{ data.item.asset_id }}</span>
                        <span class="pl-2">{{ data.item.asset_number }}</span>
                    </span>
                </template>
                <template slot="master_asset_barcode" slot-scope="data">
                    <span class="d-flex">
                        <span class="border-right pr-2">{{ data.item.barcode }}</span>
                        <span class="pl-2">{{ data.item.barcode_number }}</span>
                    </span>
                </template>
                <template slot="master_asset_cabinet_size" slot-scope="data">
                    <span class="d-flex">
                        <span class="border-right pr-2">{{ data.item.cabinet_size_num }}</span>
                        <span class="pl-2">{{ data.item.cabinet_size }}</span>
                    </span>
                </template>
                <template slot="cabinet_model" slot-scope="data">
                    <span class="d-flex">
                        <span class="border-right pr-2">{{ data.item.cabinet_model_code }}</span>
                        <span class="pl-2">{{ data.item.cabinet_model_description }}</span>
                    </span>
                </template>
                <template slot="master_asset_cabinet_sub_type" slot-scope="data">
                    <span class="d-flex">
                        <span class="border-right pr-2">{{ data.item.cabinet_subtype_code }}</span>
                        <span class="pl-2">{{ data.item.cabinet_subtype_description }}</span>
                    </span>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "AssetMasterTable",
    data() {
        return {
            fields: [
                { key: "country", sortable: true },
                { key: "dt", sortable: true },
                { key: "site", sortable: true },
                { key: "salesman", sortable: true },
                { key: "route_id", label: "Route ID", sortable: true },
                { key: "outlet", sortable: true },
                { key: "asset", sortable: true },
                { key: "master_asset_barcode", sortable: true },
                { key: "master_asset_cabinet_size", sortable: true },
                {
                    key: "cabinet_model",
                    label: "Master Asset Cabinet Model",
                    sortable: true
                },
                { key: "master_asset_cabinet_sub_type", sortable: true },
                {
                    key: "serial_number",
                    label: "Master Asset Serial No.",
                    sortable: true
                },
                {
                    key: "movement_date",
                    label: "Master Asset Movement Date",
                    sortable: true,
                    formatter: value => {
                        return this.$moment(value).format("DD MMM YYYY");
                    }
                },
                {
                    key: "ngdms_cabinet_brand",
                    label: "NGDMS: Cabinet Brand",
                    sortable: true
                },
                {
                    key: "ngdms_cabinet_brand_type",
                    label: "NGDMS: Cabinet Type", sortable: true
                },
                { key: "count", label: "Count of Asset", sortable: true }
            ],
            page: 1
        };
    },
    computed: {
        ...mapState("reportsAsset", ["loading", "param", "list"])
    },
    created: async function() {
        let param = await {
            keyword: null,
            filter: null
        };
        let limit = this.$moment(new Date()).format("M");
        let page = 1;
        await this.$store.commit("reportsAsset/setParam", {
            param,
            page
        });
        await this.getList();
    },
    methods: {
        getList: async function() {
            await this.$store.dispatch("reportsAsset/getList", this.param);
        }
    }
}
</script>
